import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, type OnInit, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCheckCircle, faExclamationTriangle, faInfoCircle, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { ENVIRONMENT_SETTINGS } from '@reconcept-platform/env';
import { BACKEND_VERSION } from '@reconcept-platform/shared/data-access';
import {
  type ToastNotification,
  ToastNotificationStyleEnum,
} from '@reconcept-platform/shared/ui/core/toast-notifications';
import { ButtonIconOnlyComponent } from '@reconcept-platform/shared/ui/standalone/button';

@Component({
  selector: 'rcp-toast-notification',
  styleUrls: ['./toast-notification.component.scss'],
  host: {
    '[class.is-shown]': 'visible',
  },
  template: `
    @if (notification(); as notification) {
      <div class="notification" [ngClass]="styleClass">
        <div>
          <fa-icon [icon]="icon()" />
        </div>

        <div class="notification-main">
          @if (!!notification.title) {
            <div class="notification-title">
              {{ notification.title }}
            </div>
          }

          @if (!!notification.message) {
            <div class="notification-message">
              {{ notification.message }}
            </div>
          }

          @if (notification.errorCode) {
            <div class="notification-footer">
              <span>{{ 'qz-error-code-zm' | translate }} {{ notification.errorCode }}</span>
              <span>v{{ appVersion }} - {{ backendVersion() }}</span>
            </div>
          }
        </div>

        @if (!notification.duration || notification.closeable) {
          <rcp-button-icon-only [icon]="faTimes" color="guaranteed-on-light" (click)="close.emit(notification)" />
        }
      </div>
    }
  `,
  imports: [NgClass, FaIconComponent, ButtonIconOnlyComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ToastNotificationComponent implements OnInit {
  notification = input<ToastNotification>();

  close = output<ToastNotification>();

  styleClass: any;
  visible: boolean;
  closeable: boolean;

  icon = computed(() => {
    // @ts-expect-error TS2532 object possibly undefined
    if (this.notification().style === ToastNotificationStyleEnum.info) {
      return this.faInfoCircle;
      // @ts-expect-error TS2532 object possibly undefined
    } else if (this.notification().style === ToastNotificationStyleEnum.success) {
      return this.faCheckCircle;
    } else {
      return this.faExclamationTriangle;
    }
  });

  appVersion = inject(ENVIRONMENT_SETTINGS).version;
  backendVersion = BACKEND_VERSION;

  protected readonly faInfoCircle = faInfoCircle;
  protected readonly faCheckCircle = faCheckCircle;
  protected readonly faExclamationTriangle = faExclamationTriangle;
  protected readonly faTimes = faTimes;
  protected readonly ToastNotificationStyleEnum = ToastNotificationStyleEnum;

  ngOnInit() {
    // timeout for animation in
    setTimeout(() => {
      this.show();
    });
  }

  private show() {
    this.visible = true;

    // set styleClass
    this.styleClass = {
      // @ts-expect-error TS2532 object possibly undefined
      [this.notification().style]: true,
    };

    // @ts-expect-error TS2532 object possibly undefined
    if (this.notification().duration) {
      // set timeout to hide
      setTimeout(() => {
        this.hide();
        // @ts-expect-error TS2532 object possibly undefined
      }, this.notification().duration);
    }
  }

  private hide() {
    this.visible = false;
  }
}
